import { React, PropTypes, reduxConnect, styled, css } from '../lib/imports';

import { Spacing, ColorProvider, Image, Heading, Text, Button } from '../components';
import { useCdnImage, getAssetSet } from '../app/context/config';
import { setRandomPlayerPicks } from '../picks/actions';
import { setElementFocused } from '../ui/actions';

const containerBaseStyles = ({ theme }) => css`
  padding: ${theme.spacings.mega} 0 ${theme.spacings.mega} ${theme.spacings.kilo};
  background-color: ${theme.colors.bl100};
  display: flex;
  border-radius: 8px;
  align-items: center;
  margin: 1px ${theme.spacings.kilo} 32px ${theme.spacings.kilo};
`;

const Container = styled('div')(containerBaseStyles);

const styledHeadingBaseStyles = ({ theme }) => css`
  font-size: 22px;
  line-height: ${theme.spacings.mega};
  letter-spacing: -1px;
  padding-bottom: ${theme.spacings.kilo};
`;

const StyledHeading = styled(Heading)(styledHeadingBaseStyles);

const bannerBaseStyles = () => css`
  display: flex;
  flex: 2;
  flex-direction: column;
`;

const Banner = styled('div')(bannerBaseStyles);

const graphicContainerBaseStyles = () => css`
  flex: 1;
  margin-left: auto;
`;

const GraphicContainer = styled('div')(graphicContainerBaseStyles);

const assetSet = (filename) => getAssetSet(useCdnImage, filename);

const styledDescriptionTextBaseStyles = ({ theme }) => css`
  line-height: 1;
  margin-right: 50px;
  padding-bottom: ${theme.spacings.bit};
`;

const StyledDescriptionText = styled(Text)(styledDescriptionTextBaseStyles);

const styledButtonBaseStyles = ({ theme }) => css`
  padding: ${theme.spacings.byte} ${theme.spacings.kilo};
  border-radius: ${theme.spacings.byte};
  border: none;
  color: ${theme.colors.bl100};
  margin-right: ${theme.spacings.peta};
  text-align: left;
  line-height: 1.2;
`;

const StyledButton = styled(Button)(styledButtonBaseStyles);

const AutoPicks = ({
  handleAutoPickClick,
  handleSetElementFocused,
  playerCounts,
  playerIds,
  playersBySlot,
  title,
  text,
  btnText,
}) => (
  <Container>
    <Banner>
      <ColorProvider variant='white'>
        <StyledHeading as='h3' size='giga' noMarginBoth bold>
          {title}
        </StyledHeading>
      </ColorProvider>
      <Spacing sizeBottom='bit'>
        <ColorProvider variant='white'>
          <StyledDescriptionText size='giga' noMargin>
            {text}
          </StyledDescriptionText>
        </ColorProvider>
      </Spacing>
      <StyledButton
        size='giga'
        variant='tertiary'
        onSelect={() => {
          handleSetElementFocused({
            picks: true,
          });
          handleAutoPickClick({
            playerCounts,
            playerIds,
            playersBySlot,
          });
        }}
      >
        {btnText}
      </StyledButton>
    </Banner>
    <GraphicContainer>
      <Image src={assetSet('bannerAutoPicks')} />
    </GraphicContainer>
  </Container>
);

AutoPicks.propTypes = {
  playerIds: PropTypes.array,
  playersBySlot: PropTypes.object,
  handleAutoPickClick: PropTypes.func,
  handleSetElementFocused: PropTypes.func,
  playerCounts: PropTypes.object,
  title: PropTypes.string,
  text: PropTypes.string,
  btnText: PropTypes.string,
};

const mapStateToProps = (state) => {
  const { strings, reminders, players } = state;
  const { isActive } = reminders;
  const { bySlotPlayerCount: playerCounts, byPlayerId, bySlotId } = players;

  const allStrings = {
    title: strings['banners/gameInfo/autoPicks/title'],
    text: strings['banners/gameInfo/autoPicks/text'],
    btnText: strings['button/autoPicks/text'],
  };

  return {
    ...allStrings,
    isActive,
    playerCounts,
    playerIds: Object.keys(byPlayerId),
    playersBySlot: bySlotId,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleAutoPickClick: (props) => dispatch(setRandomPlayerPicks(props)),
    handleSetElementFocused: (element) => dispatch(setElementFocused(element)),
  };
};

export default reduxConnect(mapStateToProps, mapDispatchToProps)(AutoPicks);
